import React from "react";
import { Select } from 'antd';

const { Option } = Select;

const sortByHeader = () => {
  return (
    <section className="car-rental-sort-header">
      <div className="car-rental-wrap d-flex justify-content-between">
        <div className="title">Car Rental in <span> Mumbai</span></div>
        <div className="sort-car d-flex justify-content-center align-items-center ">
          <div className="sort-by">Sort by:</div>
          <div className="sort-by-popularity">
            {" "}
            <Select
              defaultValue="Popularity"
              style={{
                width: 150,
              }}
              bordered={false}
            >
              <Option value="jack">Top Rated</Option>
              <Option value="lucy">Most Brought</Option>
              <Option value="Yiminghe">Trending</Option>
            </Select>
          </div>
        </div>
      </div>
    </section>
  );
};

export default sortByHeader;
